import { render } from "./DocumentsComponent.vue?vue&type=template&id=75bb4ca3"
import script from "./DocumentsComponent.vue?vue&type=script&lang=js"
export * from "./DocumentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__